/* ═══════════════════════════════════════════════════════════
   ByEllPill — Theme JavaScript
   Combined: scroll reveal · marquee duplication · counter animation
            3D tilt cards · FAQ accordion · menu toggle
   ═══════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {
  /* ── Scroll-triggered reveal animations ── */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  /* ── Duplicate marquee tracks for seamless infinite loops ── */
  document.querySelectorAll('.testimonial-marquee-track, .marquee-strip-track').forEach(track => {
    Array.from(track.children).forEach(child => {
      const clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  });

  /* ── Animated counters (0 → target) when scrolled into view ── */
  const counters = document.querySelectorAll('.cred-counter');
  if (counters.length) {
    const counterObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseInt(el.dataset.target, 10);
          const duration = 1800;
          const start = performance.now();
          const step = (now) => {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.floor(target * eased);
            if (progress < 1) requestAnimationFrame(step);
            else el.textContent = target;
          };
          requestAnimationFrame(step);
          counterObserver.unobserve(el);
        }
      });
    }, { threshold: 0.45 });
    counters.forEach(c => counterObserver.observe(c));
  }

  /* ── 3D tilt-on-mousemove for belief cards (skips on touch) ── */
  const isTouch = window.matchMedia('(hover: none)').matches;
  if (!isTouch) {
    document.querySelectorAll('.belief-card').forEach(card => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;
        const rotY = (x - 0.5) * 7;
        const rotX = (0.5 - y) * 7;
        card.classList.add('is-tilting');
        card.style.setProperty('--tilt-y', rotY + 'deg');
        card.style.setProperty('--tilt-x', rotX + 'deg');
      });
      card.addEventListener('mouseleave', () => {
        card.classList.remove('is-tilting');
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  }

  /* ── FAQ accordion ── */
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen);
    });
  });

  /* ── Menu toggle ── */
  const menuToggle = document.querySelector('.menu-toggle');
  const menuOverlay = document.querySelector('.menu-overlay');

  const closeMenu = () => {
    menuOverlay.classList.remove('is-open');
    menuToggle.classList.remove('is-open');
    menuToggle.setAttribute('aria-label', 'Open menu');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  const openMenu = () => {
    menuOverlay.classList.add('is-open');
    menuToggle.classList.add('is-open');
    menuToggle.setAttribute('aria-label', 'Close menu');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  if (menuToggle && menuOverlay) {
    menuToggle.addEventListener('click', () => {
      menuOverlay.classList.contains('is-open') ? closeMenu() : openMenu();
    });

    const closeBtn = menuOverlay.querySelector('.menu-overlay-close');
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);

    document.querySelectorAll('.menu-overlay-list a, .menu-overlay-footer a').forEach(link => {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menuOverlay.classList.contains('is-open')) closeMenu();
    });
  }
});
